import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./MainHome.scss";
import newRequest from "../../utils/newRequest.js";
import { motion } from "framer-motion";
import { ScaleLoader } from "react-spinners";
import CircularButton, { CustomLoadingButton } from "../../components/ui/CustomButton.jsx";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import "react-day-picker/dist/style.css";
import { activeStatuses } from "../../utils/core.js";
import SubscriptionBanner from "../../components/subscriptionBanner/SubscriptionBanner.jsx";
import Announcements from "../../components/announcement/Announcements.jsx";
import Todolist from "../../components/todolist/Todolist.jsx";
import OnlineUsers from "../../components/onlineUsers/OnlineUsers.jsx";
import { useTranslation } from "react-i18next";
import StatsDashboard from "../../components/statsDashboard/StatsDashboard.jsx";
import RiskNotesWidget from "../../components/homeWidgets/RiskNotesWidget.jsx";
import ReceiptsWidget from "../../components/homeWidgets/ReceiptsWidget.jsx";
import PaymentsWidget from "../../components/homeWidgets/PaymentsWidget.jsx";
import FavMenuWidget from "../../components/homeWidgets/FavMenuWidget.jsx";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { IoMdRefresh } from "react-icons/io";
import { showToast } from "../../toastService.js";
import OnboardingChecklist from "../../components/onboardingChecklist/OnboardingChecklist.jsx";
import { useNavigate } from "react-router-dom";
import VideoPlayer from "../../components/videoPlayer/VideoPlayer.jsx";
import { MdClose } from "react-icons/md";
import MobileMenu from "../../components/homeWidgets/MobileMenu.jsx";
import UwPolicyList from "../uw/uwPolicyList/UwPolicyList.jsx";
import UwRiskMap from "../uw/uwRiskMap/UwRiskMap.jsx";



const MainHome = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const socket = useSelector((state) => state.socket.socket);
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const { currentUser, showSubBanner } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isLoading, setIsLoading] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [userWidgets, setUserWidgets] = useState([]);
  const [orgOpened, setOrgOpened] = useState(currentUser?.org_opened_xx);
  const [showVideo, setShowVideo] = useState(false);



  const refreshStats = async () => {
    try {
      const res = await newRequest.get("/stats/refreshStats");
      // console.log(`refreshStats  ${JSON.stringify(res.data, null, 2)}`);
      showToast("Job queued!", "success");
    } catch (err) {
      console.log(err);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    // Add these guards
    if (!userWidgets) return;
    if (result.source.index === result.destination.index) return;

    const newWidgets = Array.from(userWidgets);
    const [moved] = newWidgets.splice(result.source.index, 1);
    newWidgets.splice(result.destination.index, 0, moved);

    // Use functional update to ensure latest state
    setUserWidgets(prev => {
      const newArray = Array.from(prev);
      const [moved] = newArray.splice(result.source.index, 1);
      newArray.splice(result.destination.index, 0, moved);
      return newArray;
    });
  };

  const handleDismiss = async () => {
    try {
      const res = await newRequest.put(`/org/upd/${currentUser.org_docid}`, { org_opened: "Y" });
      setOrgOpened("Y");
    } catch (error) {
      console.log(error);
    }
  };

  const widgetMap = {
    StatsDashboard: <StatsDashboard />,
    RiskNotesWidget: <RiskNotesWidget />,
    FavMenuWidget: <FavMenuWidget />,
    ReceiptsWidget: <ReceiptsWidget />,
    PaymentsWidget: <PaymentsWidget />,
    OnlineUsersWidget: <OnlineUsers />,
  };

  useEffect(() => {
    if (currentUser?.usr_widgets) {
      const sorted = currentUser.usr_widgets
        .filter((w) => w.widget_visible)
        .sort((a, b) => a.widget_order - b.widget_order);
      setUserWidgets(sorted);
    } else {
      setUserWidgets([]);
    }
    // console.log(`currentUser?.first_time ... ${currentUser?.first_time}`);
    if (currentUser?.first_time === "Y") {
      const hasSeenVideo = localStorage.getItem(
        `welcomeVideoSeen_${currentUser?.usr_id.toString()}`
      );
      console.log(`hasSeenVideo ... ${hasSeenVideo}`);
      if (!hasSeenVideo) {
        setShowVideo(true);
      }
    }
  }, [currentUser]);



  return (
    <motion.div
      className="main-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}>
      {isLoading ? (
        <div className="no-content">
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="home-main-wrapper">
          {activeStatuses.includes(currentUser?.subscription_status_xx) &&
            <div className="home-content-wrapper">
              {showSubBanner === "Y" && <SubscriptionBanner currentUser={currentUser} />}
              <div className="home-container">
                {orgOpened === "N" && <OnboardingChecklist handleDismiss={handleDismiss} />}
                <div className="mobile-content">
                  <MobileMenu />
                </div>
                {!currentUser?.usr_entity_code ?
                  <div className="home-content">
                    {/* {currentUser?.first_time === "Y" &&
                    <div className="welcome-message">
                      <span className="main-title">{t('welcomeMessage', { param1: currentUser?.usr_full_name, param2: t('appName') })}</span>
                      <VideoPlayer videoUrl="welcome" />
                      <span className="welcome-footer"><p className="sub-title soft" style={{ fontSize: "10px" }}>{t('videoWontDisplay')}</p></span>
                    </div>} */}
                    {userWidgets.map((widget, index) => {
                      if (!widget.widget_visible) return null;
                      const Component = widgetMap[widget.widget_name];
                      return (
                        <div key={String(widget._id)} className={`widget-wrapper ${widget.widget_name === "StatsDashboard" ? "stats" : ""}`}>
                          {/* <hr className="separator-h" /> */}
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="sub-title">{widget.widget_name.replace(/([A-Z])/g, ' $1').toUpperCase()}</span>
                            {widget.widget_name === "StatsDashboard" && <span className="sub-title view-all" onClick={refreshStats}><IoMdRefresh size={15} /> {t('refresh')}</span>}
                            {widget.widget_name === "ReceiptsWidget" && <span className="sub-title view-all" onClick={() => navigate(`/receipts`, { state: { showBack: "Y", menuDocid: "1111", favMenu: "Y" } })}  >{t('viewAll')}</span>}
                            {widget.widget_name === "PaymentsWidget" && <span className="sub-title view-all" onClick={() => navigate(`/payments`, { state: { showBack: "Y", menuDocid: "1111", favMenu: "Y" } })}  >{t('viewAll')}</span>}
                            {widget.widget_name === "RiskNotesWidget" && <span className="sub-title view-all" onClick={() => navigate(`/docs/risknote`, { state: { showBack: "Y", menuDocid: "1111", favMenu: "Y" } })}  >{t('viewAll')}</span>}
                          </div>
                          {Component}
                        </div>
                      );
                    })}
                    {/* <div className="home-content">
                      <UwRiskMap />
                    </div> */}
                  </div> :
                  <div className="home-content">
                    <UwPolicyList passedDocType={"RiskNote"} />
                  </div>
                }
                {/* <div className="home-content">
                      <WidgetsDraggable widgets={userWidgets} onDragEnd={handleDragEnd} />
                    </div> */}
              </div>
            </div>}
          {activeStatuses.includes(currentUser?.subscription_status_xx) &&
            <div className="summary-wrapper">
              <div className="summary-content">
                {/* <OnlineUsers /> */}
                <Todolist />
                <Announcements />
              </div>
            </div>}
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {showVideo && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('welcomeMessage', { param1: currentUser?.usr_full_name, param2: t('appName') })}</span>
              <CircularButton currentTheme={currentTheme}
                onClick={() => {
                  setShowVideo(false);
                  localStorage.setItem("welcomeVideoSeen", "true");
                }} icon={<MdClose />}
                width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="welcome-message">
                <VideoPlayer videoUrl="welcome" />
                <span className="welcome-footer"><p className="sub-title soft" style={{ fontSize: "10px" }}>{t('videoWontDisplay')}</p></span>
              </div>
            </div>
            <div className="overlay-actions">
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

function WidgetsDraggable({ widgets, onDragEnd }) {
  const widgetMap = {
    StatsDashboard: <StatsDashboard />,
    RiskNotesWidget: <RiskNotesWidget />,
    FavMenuWidget: <FavMenuWidget />,
    ReceiptsWidget: <ReceiptsWidget />,
    PaymentsWidget: <PaymentsWidget />,
    OnlineUsersWidget: <OnlineUsers />,
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="widgetList">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {widgets.map((widget, index) => (
              <Draggable
                key={String(widget?._id)}
                draggableId={String(widget?._id)}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="widget-wrapper"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <span className="sub-title">
                        {widget?.widget_name.replace(/([A-Z])/g, ' $1').toUpperCase()}
                      </span>
                      <span className="drag-handle">[{widget?._id}] ⇅ Drag</span>
                    </div>
                    {widgetMap[widget?.widget_name]}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}


export default MainHome;
